<template>

    <div class="customer-card" @click="viewCustomer">
        <div class="customer-content">
            <v-avatar
                :name="customer.name"
                :color="customer.color"
                :url="customer.photo ? customer.photo.link : customer.gravatar"
                :size="80"
                :radius="5"
                :border="2">
            </v-avatar>
            <div class="customer-info">
                <span class="name">{{ customer.name }}</span>
                <span v-if="customer.email" class="channel">{{ customer.email }}</span>
                <span v-if="customer.phone_formatted" class="channel">{{ customer.phone_formatted }}</span>
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .customer-card {
        background-color: $color-white;
        border: 1px solid $color-rule;
        border-radius: 5px;
        cursor: pointer;
        overflow: hidden;
        position: relative;
        transition: border-color .3s;
        &:hover {
            border-color: $color-text;
        }
    }

    .customer-content {
        align-items: center;
        display: flex;
        padding: 10px;
        position: relative;
        z-index: 1;
    }

    .customer-info {
        display: flex;
        flex-direction: column;
        gap: 5px;
        overflow: hidden;
        padding: 10px;
        text-align: left;
        .name {
            @include font-semibold(14px);
            color: $color-text;
            line-height: normal;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .channel {
            @include font-regular(13px);
            color: $color-muted;
            display: block;
            line-height: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            a {
                color: $color-muted;
            }
        }
    }

    .customer-cta {
        bottom: 0;
        color: $color-text;
        font-size: 16px;
        margin: 10px;
        opacity: 0.3;
        position: absolute;
        transition: opacity .3s;
        right: 0;
    }

    .customer-bg {
        position: absolute;
        height: 20%;
        left: 0;
        top: 0;
        width: 100%;
        z-index: 0;
        &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(to right, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2) 100%);
            z-index: -1;
        }
    }

</style>

<script>

import Avatar from '@cmp/Avatar';

export default {

    components: {
        'v-avatar': Avatar,
    },

    props: {
        customer: {
            type: Object,
            required: true,
        },
    },

    methods: {

        viewCustomer() {
            this.$router.push({
                name: 'customers.show',
                params: { id: this.customer.id },
            }).catch(() => {});
        },

    },

}

</script>